
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

import GET_CONTRACTOR_NOTE from "@/apollo/contractors/GetContractorNote.gql";
import UiButtonMessage from "@/components/button/ui-button-message.vue";
import InformationCard from "@/components/inforationCards/InformationCard.vue";
import MailTo from "@/components/common/MailTo.vue";
import PhoneTo from "@/components/common/PhoneTo.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import UILink from "@/components/common/UILink.vue";
import CardBodyItem from "@/components/card/CardBodyItemNew.vue";
import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholderNew.vue";
import EmptyListImageDocuments from "@/components/icons/emptyListImages/EmptyListImageDocuments.vue";
import CardPagination from "@/components/card/PaginationNew.vue";
import PaginationConfig from "@/entities/PaginationConfig";
import paginationConfig from "@/data/paginationConfig";
import RouteParams from "@/entities/RouteParams";
import RouteNames from "@/entities/RouteNames";
import AddNotesModal from "@/components/common/AddNotesModalNew.vue";
import AddNotesToContractor from "@/components/contractors/AddNotesToContractorsNew.vue";
import ContractorNote from "@/components/companyContractors/ContractorNote.vue";
import ContractorNoteCard from "@/components/contractors/ContractorNoteCardNew.vue";

@Component({
  components: {
    ContractorNote,
    AddNotesToContractor,
    EmptyListPlaceholder,
    EmptyListImageDocuments,
    InformationCard,
    MailTo,
    AddNotesModal,
    UiButtonMessage,
    LoadingOverlay,
    UILink,
    PhoneTo,
    CardPagination,
    CardBodyItem,
    ContractorNoteCard,
  },
  apollo: {
    contractorNotes: {
      query: GET_CONTRACTOR_NOTE,
      variables() {
        return this.contractorId_;
      },
      update(data) {
        // this.contractorNotes = data.contractor_note;
        this.paginationConfig.loadedCount = data.contractor_note.length;
        return data.contractor_note;
      },
    },
  },
})
export default class Notes extends Vue {
  @Prop({ type: String, required: true }) readonly contractorUserId!: string;
  @Prop({ type: String, required: true }) readonly contractorId!: string;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: String, required: true }) readonly contractorFullName!: string;
  @Prop({ type: String, default: undefined }) readonly buttonSize?: string;

  editModal: boolean = false;
  modalShown: boolean = false;

  showEdit(): void {
    this.editModal = true;
  }

  showModal(): void {
    this.modalShown = true;
  }

  closeModal(): void {
    this.modalShown = false;
  }

  closeEdit(): void {
    this.editModal = false;
  }

  async addNotesToContractors(): Promise<void> {
    this.closeModal();
    this.updateNotesList();
  }
  contractorNotes: any[] = [];
  processing: boolean = false;
  paginationConfig: PaginationConfig = { ...paginationConfig };

  get contractorId_(): Object {
    return {
      contractor_id: this.contractorId,
    };
  }

  get isLoading(): boolean {
    return this.$apollo.queries.contractorNotes.loading || this.processing;
  }

  get isDataLoaded(): boolean {
    return Boolean(this.contractorNotes);
  }

  get isNotesExist(): boolean {
    return this.contractorNotes.length > 0 ? true : false;
  }

  get emptyListSubtitle(): string {
    return `Start adding notes to ${this.contractorFullName}`;
  }

  get contractorProjectsLink(): RouteParams<{ id: string }> {
    return {
      name: RouteNames.CONTRACTOR_DETAILS_PROJECTS,
      params: { id: this.contractorId },
    };
  }

  async updateNotesList(): Promise<void> {
    this.processing = true;
    this.$apollo.queries.contractorNotes.refetch();
    this.processing = false;
  }
}
